import { BeneListService } from '../../services/beneList.service';
import { CityListService } from '../../../../common/services/cityList.service';

export class CommonGuiPart {
  static async getLocObjByZipCode(
    zip: string,
    beneListService: BeneListService,
    channel: string
  ): Promise<CityListService | null> {
    if (!zip) {
      return null;
    }

    const location = await beneListService.controller.publicGetLocationByZip(zip);
    if (!location) {
      return null;
    }

    return new CityListService(channel, location);
  }
}
